import type { EditorPlugin } from '../../../types/aha-editor';
import { concatenateStyle } from '../utils';
import ColorUtils from '../../../util/color';

const TextHighlightMarkPlugin: EditorPlugin = {
  name: 'Text highlight mark plugin',
  mark: {
    type: 'textHighlight',
    use: ({ leaf, props }) => {
      const color = leaf.textHighlight
        ? ColorUtils.mapColorFromColorPickerToDarkMode(leaf.textHighlight)
        : undefined;

      return concatenateStyle({ ...props }, 'backgroundColor', color);
    },
  },
};
export default TextHighlightMarkPlugin;
